module.exports = __webpack_public_path__ + "img/check.fb373bcd.svg";